export default __webpack_public_path__ + "static/media/iconSoporte.d593cbc5.svg";